import React from 'react';
import { Flame, Users, HeartPulse, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Flame size={32} data-id="element-117" />,
    title: 'HIIT Group Classes',
    desc: 'High-intensity interval training designed to torch calories, build endurance, and push your limits — together, every session.'
  }, {
    icon: <Users size={32} data-id="element-118" />,
    title: 'Coach-Led Programming',
    desc: 'Every class is led by expert coaches who scale workouts to your level. No guesswork — just show up and crush it.'
  }, {
    icon: <HeartPulse size={32} data-id="element-119" />,
    title: 'Community & Accountability',
    desc: "You don't just train here — you belong here. Real friendships, shared goals, and people who hold you to your best."
  }];
  return <section id="classes" className="py-24 bg-prt-dark" data-id="element-120">
      <div className="container mx-auto px-6" data-id="element-121">
        <div className="mb-16" data-id="element-122">
          <span className="text-prt-tan font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-123">
            What We Offer
          </span>
          <h2 className="font-heading text-white text-4xl md:text-5xl" data-id="element-124">
            Group Training Built for Real Results
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-125">
          {services.map((service, i) => <div key={i} className="bg-prt-surface p-8 rounded-lg border-t-4 border-transparent hover:border-prt-blue transition-all duration-300 group cursor-pointer" data-id="element-126">
              <div className="text-prt-blue mb-6" data-id="element-127">{service.icon}</div>
              <h3 className="text-white font-heading text-2xl tracking-wide mb-4" data-id="element-128">
                {service.title}
              </h3>
              <p className="text-prt-muted mb-8" data-id="element-129">{service.desc}</p>
              <div className="flex items-center text-prt-blue font-medium uppercase tracking-wider text-sm group-hover:translate-x-2 transition-transform" data-id="element-130">
                Learn More <ArrowRight size={16} className="ml-2" data-id="element-131" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}